export const GEOMETRY_ADD = 'GEOMETRY_ADD';
export const GEOMETRY_UPDATE_COLOR = 'GEOMETRY_UPDATE_COLOR';
export const ACTIVE_GEOMETRY_SET = 'ACTIVE_GEOMETRY_SET';
export const WIREFRAME_SWITCH = 'WIREFRAME_SWITCH';

export const COLORMAP_UPDATE = 'COLORMAP_UPDATE';
export const OPACITY_UPDATE = 'OPACITY_UPDATE';
export const CLIPPING_SWITCH = 'CLIPPING_SWITCH';

export const CAMERA_NEAR_SET = 'CAMERA_NEAR_SET';